import Invite from '@/models/Invite'
import User from '@/models/User'

export default class InvitePolicy {
	viewAny(_user: User): boolean {
		return false
	}

	view(_user: User, _invite: Invite): boolean {
		return false
	}

	create(_user: User): boolean {
		return true
	}

	update(_user: User, _invite: Invite): boolean {
		return false
	}

	restore(_user: User, _invite: Invite): boolean {
		return false
	}

	delete(_user: User, _invite: Invite): boolean {
		return false
	}

	forceDelete(_user: User, _invite: Invite): boolean {
		return false
	}
}
